import z from 'zod'
import type { RestApiClient } from '../../utils/createRestApiClient'

let cachedResponse: z.infer<typeof metaSchema> | undefined

/** Hyperliquid のスポット取引のメタ情報を取得する
 * - 初回取得後はキャッシュを返す
 */
export const fetchSpotMetaInfo = async (params: {
  client: RestApiClient
}) => {
  const { client } = params

  if (cachedResponse) {
    return cachedResponse
  }

  const response = await client.run({
    method: 'POST',
    path: '/info',
    body: {
      type: 'spotMeta',
    },
    responseSchema: metaSchema,
  })

  cachedResponse = response
  return response
}

const metaSchema = z.object({
  tokens: z.array(
    z.object({
      name: z.string(),
      szDecimals: z.number().optional(),
      weiDecimals: z.number().optional(),
      index: z.number().optional(),
      tokenId: z.string().optional(),
      isCanonical: z.boolean().optional(),
      evmContract: z
        .object({
          address: z.string().optional(),
          evm_extra_wei_decimals: z.number().optional(),
        })
        .nullable(),
      fullName: z.string().nullable().optional(),
    }),
  ),
  universe: z.array(
    z.object({
      name: z.string(),
      tokens: z.tuple([z.number(), z.number()]),
      index: z.number(),
      isCanonical: z.boolean(),
    }),
  ),
})
